import {billingEntities} from '@/utils/pricing'
import {routeTo} from '@/utils/router'

export const usePaymentCheckoutContent = () => {
  return {
    title: 'forms.payment-method-step-title',
    paymentTitle: 'forms.payment-title',
    paymentDetailsTitle: 'forms.payment-details-title',
    copyText: 'copy-text',
    transfer: {
      title: 'checkout-reg-transfer-payment',
      bankName: 'inv-bank',
      variableSymbol: 'inv-variable-symbol',
      dueDate: 'inv-due-date',
      buttonText: 'checkout-reg-pay-later',
      refNumberNotice: 'ref-number-notice',
      bankDetails: {
        EU: [
          {
            title: 'inv-account-holder',
            value: billingEntities.SK.bankDetails.EU.accountHolder,
          },
          {
            title: 'inv-iban',
            value: billingEntities.SK.bankDetails.EU.iban,
            hasClipboard: true,
            isHighlighted: false,
            notice: null,
          },
          {
            title: 'inv-bank-swift',
            value: billingEntities.SK.bankDetails.EU.bic,
            hasClipboard: true,
          },
          {
            title: 'inv-bank-name',
            value: billingEntities.SK.bankDetails.EU.bankName,
            hasClipboard: true,
          },
          {
            title: 'inv-bank-address',
            value: billingEntities.SK.bankDetails.EU.bankAddress,
          },
        ],
        GB: [
          {
            title: 'inv-account-holder',
            value: billingEntities.SK.bankDetails.GB.accountHolder,
          },
          {
            title: 'inv-bank-account',
            value: billingEntities.SK.bankDetails.GB.accountNumber,
            hasClipboard: true,
            isHighlighted: false,
            notice: null,
          },
          {
            title: 'inv-sort-code',
            value: billingEntities.SK.bankDetails.GB.sortCode,
            hasClipboard: true,
          },
          {
            title: 'inv-bank-name',
            value: billingEntities.SK.bankDetails.GB.bankName,
            hasClipboard: true,
          },
          {
            title: 'inv-bank-address',
            value: billingEntities.SK.bankDetails.GB.bankAddress,
          },
        ],
      },
    },
    creditCard: {
      title: 'checkout-reg-card-payment',
      cardholder: 'checkout-reg-cardholder',
      cardholderPlacehoder: 'checkout-reg-cardholder-placeholder',
      cardDetails: 'checkout-reg-card-details',
      buttonText: 'checkout-reg-pay',
      disabledText: 'checkout-reg-card-payment-disabled',
      saveCardCheckbox: 'save-credit-card-checkbox-label',
      expiresOnDate: 'card-expiration-date-title',
      payWithDifferentCard: 'pay-with-different-card-title',
      selectOneOfSavedCards: 'select-one-of-saved-cards-title',
      paymentFailedErrorMessage: 'error-payment-failed',
    },
    wallet: {
      buttonText: 'checkout-reg-pay-with',
    },
    copyToClipboardText: 'copy-to-clipboard-text',
    copiedToClipboardText: 'copied-to-clipboard-text',
    successInfo: {
      title: 'payment-modal-success-title',
      description: 'payment-modal-success-description',
      buttonText: 'close-btn-text',
    },
    downloadProformaInvoice: 'download-proforma-invoice',
    paymentLink: {
      title: 'forms.payment-step-payment-link-title',
      description: 'forms.payment-step-payment-link-desc',
      label: 'forms.payment-step-payment-link-label',
      buttonText: 'forms.payment-step-copy-payment-link',
    },
    consentNote: {
      general: {
        note: 'forms.payment-step-consent-note-1',
        linkHrefs: [routeTo.termsAndConditions()],
      },
      us: {
        note: 'forms.payment-step-consent-note-2',
        linkHrefs: [routeTo.termsAndConditions(), routeTo.engagementLetter()],
      },
    },
  }
}
